/**
 * This function is used as one of the options for the style-loader in webpack.
 */
function styleOverrideFunction() {
  //The element passed in here normally gets attached to the head.
  //However, we are making this a no-op in favor of using the
  //styleTagTransform function.
}

export default styleOverrideFunction;